import Vue from 'vue';

// Bugsnag
import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
    apiKey: '5dae7f69210537af14481019d72be01d',
    plugins: [new BugsnagPluginVue()],
    enabledReleaseStages: ['production'],
    releaseStage: process.env.NODE_ENV,
});

BugsnagPerformance.start({
    apiKey: '5dae7f69210537af14481019d72be01d',
    enabledReleaseStages: ['production'],
    releaseStage: process.env.NODE_ENV,
})

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue);

export default Bugsnag;